import { render, staticRenderFns } from "./signupSuccess.vue?vue&type=template&id=73cd1daa&scoped=true&"
import script from "./signupSuccess.vue?vue&type=script&lang=js&"
export * from "./signupSuccess.vue?vue&type=script&lang=js&"
import style0 from "./signupSuccess.vue?vue&type=style&index=0&id=73cd1daa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73cd1daa",
  null
  
)

export default component.exports